import { api } from "@/lib/api"
import { logger } from "@/utils/logger"
import { useMutation } from "@tanstack/react-query"

export function useVerifiedFields() {
	const useSetVerifiedFields = (
		university_id: string,
		batch_id: string,
		application_id: string,
	) => {
		return useMutation({
			mutationFn: async (
				payload: {
					field_id: string
					is_verified: boolean
				}[],
			) => {
				logger.info("verified fields api called", payload)
				const refactoredPayload = payload.map(p => ({
					field_id: p.field_id,
					is_verified: p.is_verified,
				}))

				const data = await api.post(
					`/universities/${university_id}/batches/${batch_id}/applications/${application_id}/verify-fields`,
					refactoredPayload,
				)

				return data
			},
			mutationKey: [
				"verified-fields",
				university_id,
				batch_id,
				application_id,
			],
		})
	}

	return {
		useSetVerifiedFields,
	}
}
